<template>
    <grid ref="grid" :columnDefs="columnDefs" :fetchCallback="fetchCallback"></grid>
</template>

<script>
import API from '../../../api';
import { TRUSTED_GUEST_ENDPOINT } from '../../../endpoints';
import { formatResponseError } from '../../../utils/api';
import grid from '../../generic/grid/grid.vue';

export default {
    components: { grid },
    data() {
        return {
            offset: 0,
            limit: 20,
            sort: 'id',
            desc: true,
            search: '',
        };
    },
    computed: {
        columnDefs() {
            return [
                {
                    field: 'id',
                    headerName: '#',
                },
                {
                    field: 'fullname',
                    headerName: 'Full Name',
                },
                {
                    field: 'email',
                    headerName: 'Email',
                },
                {
                    field: 'is_trusted',
                    headerName: 'Trusted',
                    type: 'switchColumn',
                    sortable: false,
                    cellRendererParams: {
                        onChange: async ({ node, api }) => {
                            try {
                                await API.post(`${TRUSTED_GUEST_ENDPOINT(node.id)}toggle-trusted-guests/`);
                            } catch (e) {
                                const { generic } = formatResponseError(e);
                                this.errorToast({ text: generic || 'Could not update trusted status' });
                                api.redrawRows({ rowNodes: [node] });
                            }
                        },
                    },
                },
            ];
        },
        fetchCallback() {
            return ({ offset, limit, sort, desc, search }) => {
                this.offset = offset;
                this.limit = limit;
                this.sort = sort;
                this.desc = desc;
                this.search = search;
                return API.get(`${TRUSTED_GUEST_ENDPOINT()}grid/`, {
                    params: {
                        offset,
                        limit,
                        sort,
                        desc,
                        search,
                    },
                });
            };
        },
    },
};
</script>

<style>
</style>